import type {ChannelCategory} from '@mattermost/types/channel_categories';
import {ChannelCategoryType} from '../constants';

export function isChannelsChannelCategory(category: ChannelCategory) {
    return category?.type === ChannelCategoryType.CHANNELS;
}
